module.exports = __webpack_public_path__ + "img/dongfangdianqi.2038fffe.png";